import { Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const SpecialCaseNote = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  return (
    <Stack>
      <Typography>{dictionary.secondSectionMentalSpecialCaseNote}</Typography>
      <Link
        sx={{ cursor: 'pointer' }}
        href={`https://shikum.mod.gov.il/recognition/terms/goren`}
      >
        {dictionary.secondSectionMentalSpecialCaseLinkText}
      </Link>
    </Stack>
  );
};
